<template>
<div>
    <div class="full-screen" v-if="!isMobile">
        <ResultsPractitionerFullScreen :result="result" :rank="rank"/>
    </div>

    <div class="mobile" v-if="isMobile">
        <ResultsPractitionerMobile :result="result" :rank="rank" />
    </div>
</div>
</template>

<script setup>

    const props = defineProps({
        result: Object,
        rank: Number
    })

    const { isMobile } = useMobile()

</script>

<style lang="scss">

.full-screen,
.mobile {
  &:hover {
    .title {
      hp5-link-text-basic {
        a {
          color: var(--color-link-dark);
        }
      }
    }
  }
}

</style>